import { history } from './history';

/**
 * Navigate to the study-not-found / permission-denied page while preserving URL
 * query params (e.g. dicomStore) used by NotFoundStudy.
 */
export function redirectToNotFoundStudy() {
  const search = window.location.search || '';
  const pathname = '/notfoundstudy';

  if (history.navigate) {
    history.navigate({ pathname, search }, { replace: true });
    return;
  }

  window.location.assign(`${pathname}${search}`);
}
